// 通用文本翻譯

export const common = {
    loading: 'Loading...',
    back: 'Back',
    download: 'Download',
    loadMore: 'Load More',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    submit: 'Submit',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',
    retry: 'Retry',
    reset: 'Reset'
  };
